import { OrderedMap, fromJS } from 'immutable';

import { ADD, ADD_MULTIPLE, REMOVE, SET_TOTAL } from './constants';

const initialState = fromJS({ organizers: OrderedMap() });

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return state.set(
        'organizers',
        state.get('organizers').set(action.organizer.id, action.organizer)
      );

    case ADD_MULTIPLE:
      return state.set('organizers', action.organizers);

    case REMOVE:
      return state.set('organizers', state.get('organizers').delete(action.id));

    case SET_TOTAL:
      return state.set('total', action.total);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
